import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setAuth } from '../../redux/authSlice';
import { useSnackbar } from 'notistack';
import { t } from 'i18next';
import Button from '@mui/material/Button';

interface TemporaryDrawerProps {
  setShowModalToils: React.Dispatch<React.SetStateAction<boolean>>;
  selectedUserToils: any;
  refreshUsers: any;
}

export default function UserToils({ setShowModalToils, selectedUserToils, refreshUsers }: TemporaryDrawerProps) {
  const [toilsNum, setToilsNum] = useState('');
  const [descriptions, setDescriptions] = useState('');
  const [userInfo, setUserInfo] = useState(0);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data } = await axios.get('user');
        if (data) {
          dispatch(setAuth(true));
          setUserInfo(data.roleId);
        }

      } catch (e) {
        // auth errors are handled by the global interceptor
      }
    };

    checkAuth();
  }, [dispatch, userInfo]);


  const handeAddToil = async () => {
    if (!toilsNum) {
      enqueueSnackbar('All fields are required', { variant: 'error' });
      return;
    }

    try {
      await axios.post('toils/add', {
        date: new Date(),
        total_sum: Number(toilsNum),
        description: descriptions,
        userId: selectedUserToils.id
      });
      refreshUsers();
      setShowModalToils(false);
      enqueueSnackbar('Add successfully', { variant: 'success' });
    } catch (error: any) {
      console.error('Error:', error);
      enqueueSnackbar('Add failed. Please try again.', { variant: 'error' });
    }
  }

  return (
    <Box sx={{
      width: 400,
      height: '200%',
      background: 'var(--bg-form)'
    }}
      role="presentation">
      <List>
        <div className='my-[5px] mx-[25px] text-[var(--text-color)]' id='reg-user-edit'>
          <div className='flex justify-end'>
            <h1 className='text-[20px] text-left font-bold'>{t('AddToils')}</h1>
          </div>
          <div className='flex flex-col justify-evenly flex-grow' >
            <hr className='hr mt-[10px]' />
            <h2 className='text-[14px] my-[5px] font-semibold text-right'>{t('Information')}</h2>
            <div className='flex flex-col w-full'>
              <label className='text-[10px] ml-[5px]'>{t('removeTOIL')}:</label>
              <input type="number"
                value={toilsNum}
                pattern="[0-9]"
                inputMode="numeric"
                className="w-full rounded-[5px] edit-input"
                onChange={e => {
                  const input = e.target.value;
                  const cleanInput = input.replace(/[^0-9.-]/g, '');
                  setToilsNum(cleanInput);
                }}
              />
            </div>
            <div className='flex gap-[5px] mt-[5px]'>
              <div className='flex flex-col w-full'>
                <label className='text-[10px] ml-[5px]'>{t('Description')}:</label>
                <textarea
                  className="w-full rounded-[5px] edit-input resize-none text-[16px]"
                  rows={2}
                  onChange={e => setDescriptions(e.target.value)}/>
              </div>
            </div>
            <hr className='hr mt-[10px] mb-[15px]' />
            <div className='flex gap-[15px] justify-center items-center'>
              <Button
                variant="contained"
                sx={{
                  padding: '4px 10px',
                  fontSize: 14,
                  width: '100%',
                  color: 'white !important'
                }}
                onClick={() => handeAddToil()}>
                {t('Add')}
              </Button>
              <Button
                variant="contained"
                sx={{
                  padding: '4px 10px',
                  fontSize: 14,
                  width: '100%',
                  color: 'white !important'
                }}
                onClick={() => setShowModalToils(false)}>
                {t('Cancel')}
              </Button>
            </div>
          </div>
        </div>
      </List>
    </Box >
  )
}